import type { SparkOptions } from '../types/spark-options';
import { parseJsObjectLiteral } from './js-object';
import { toSparkJsOptions } from './sparkjs-options';
import type { ImportWarnings } from './warnings';

/** Write the options out as a `window.sparkOptions` snippet to paste into a theme. */
export function serializeSparkOptions(options: SparkOptions): string {
  return `window.sparkOptions = ${JSON.stringify(toSparkJsOptions(options), null, 2)};`;
}

/** Read the options object out of a pasted snippet (with or without the `window.sparkOptions =` wrapper). */
export function parseSparkOptionsSnippet(
  text: string,
  warnings?: ImportWarnings,
): Record<string, unknown> {
  return parseJsObjectLiteral(text, warnings);
}
